"use strict";

// Class definition
var KTCardWidget12 = function () {
    var element = document.getElementById("kt_card_widget_12_chart");

    // Private methods
    var initChart = function(isAccident) {

        if (!element) {
            return;
        }

        var height = parseInt(KTUtil.css(element, 'height'));       
        var borderColor = KTUtil.getCssVariableValue('--bs-border-dashed-color');
        var baseColor = isAccident ? KTUtil.getCssVariableValue('--bs-danger') : KTUtil.getCssVariableValue('--bs-gray-800');
        var lightColor = isAccident ? KTUtil.getCssVariableValue('--bs-danger') : KTUtil.getCssVariableValue('--bs-success');
        var reportArray;
        var reportTitle;

        if (isAccident){
            var reportArray = isKazalariRapor.map(obj => obj.value);
            var reportTitle = isKazalariRapor.map(obj => obj.name);
        } else{
            var reportArray = uretimRaporOzet.map(obj => obj.value);
            var reportTitle = uretimRaporOzet.map(obj => obj.name);
        }

        var options = {
            series: [{
                name: isAccident ? 'Kaza Sayısı' : 'Üretim Adedi',
                
                data: reportArray
            }],
            chart: {
                fontFamily: 'inherit',
                type: 'area',
                height: height,
                toolbar: {
                    show: false
                }
            },             
            legend: {
                show: false
            },
            dataLabels: {
                enabled: false
            },
            fill: {
                type: 'solid',
                opacity: isAccident ? 0.1 : 0
            },
            stroke: {
                curve: 'smooth',
                show: true,
                width: 2,
                colors: [baseColor]
            },
            xaxis: {                 
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false
                },
                labels: {
                    show: false
                },
                crosshairs: {
                    position: 'front',
                    stroke: {
                        color: baseColor,
                        width: 1,
                        dashArray: 3
                    }
                },
                tooltip: {
                    enabled: true,
                    formatter: undefined,
                    offsetY: 0,
                    style: {
                        fontSize: '12px'
                    }
                }
            },
            yaxis: {
                labels: {
                    show: false
                }
            },
            states: {
                normal: {
                    filter: {
                        type: 'none',
                        value: 0
                    }
                },
                hover: {
                    filter: {
                        type: 'none',
                        value: 0
                    }
                },
                active: {
                    allowMultipleDataPointsSelection: false,
                    filter: {
                        type: 'none',
                        value: 0
                    }
                }
            },
            tooltip: {
                style: {
                    fontSize: '12px'
                },
                x: {
                    formatter: function (val) {
                        return reportTitle[val-1];
                    }
                },
                y: {
                    formatter: function (val) {
                        return val;
                    }
                }
            },
            colors: [lightColor],
            grid: {                 
                strokeDashArray: 4,
                padding: {
                    top: 0,
                    right: -10,
                    bottom: -20,
                    left: -10
                },
                yaxis: {
                    lines: {
                        show: true
                    }
                }
            },
            markers: {
                strokeColor: baseColor,
                strokeWidth: 2
            }
        }; 

        var chart = new ApexCharts(element, options);
        
        // Set timeout to properly get the parent elements width
        setTimeout(function() {
            chart.render();   
        }, 300);  
    }


    // Public methods
    return {
        init: function () {
            element?.dataset.isAccident === "true" ? initChart(true) : initChart(false)
            
        }   
    }

}();

// Webpack support
if (typeof module !== 'undefined') {
    module.exports = KTCardWidget12;
}

// On document ready
KTUtil.onDOMContentLoaded(function() {
    KTCardWidget12.init();
});
